<template>
  <div class="us_app">
    <section class="user_section">
      <article class="view cmnity">
        <div class="formula_title_wrap">
          <img src="@/assets/images/formula.png" alt="코끼리 비방사전" class="title_formula_img" />
        </div>
        <div class="search_box" style="flex-wrap: wrap">
          <p class="w100 mb20">
            총
            <strong> {{ formulaLibraryList.length }} </strong>건
          </p>

          <div class="form_inline search_row">
            <div class="search_fields">
              <span class="fwb">카테고리</span>
              <div class="form_select">
                <b-form-select v-model="searchInfo.prescribe_category" style="width: 200px" @change="fn_change_prescript_catarory">
                  <b-form-select-option value="">선택</b-form-select-option>
                  <b-form-select-option v-for="(item, index) in prescrbeCategoryList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                </b-form-select>
                <b-form-select v-model="searchInfo.prescribe_sub_category" class="ml10" style="width: 200px">
                  <b-form-select-option value="">선택</b-form-select-option>
                  <b-form-select-option v-for="(item, index) in prescrbeSubCategoryList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                </b-form-select>
              </div>
              <span class="fwb">비방명</span>
              <input
                type="text"
                class="form_control"
                placeholder="입력하세요."
                v-model="searchInfo.prescribe_nm"
              />
            </div>
            <button class="btn btn_md btn_darkbrown" @click="fn_search">검색</button>
          </div>
          <div class="form_inline search_row mt10">
            <div class="search_fields">
              <span class="fwb">키워드</span>
              <input
                type="text"
                class="form_control"
                placeholder="입력하세요."
                v-model="searchInfo.indications"
              />
              <span class="fwb">등록자</span>
              <input
                type="text"
                class="form_control"
                placeholder="입력하세요."
                v-model="searchInfo.doctor_nm"
              />
            </div>
            <button class="btn btn_md btn_brown" @click="fn_move_mySecret">내비방관리 및 등록</button>
          </div>
        </div>

        <div class="tab_contents">
          <div class="lay_left">
            <div class="table_list">
              <table class="list">
                <colgroup>
                  <col width="50" />
                  <col width="200" />
                  <col width="150" />
                  <col width="250" />
                  <col width="100" />
                  <col width="100" />
                  <col width="100" />
                  <col width="100" />
                  <col width="100" />
                </colgroup>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>비방처방명</th>
                    <th>카테고리</th>
                    <th>적응중(처방 키워드)</th>
                    <th>출처</th>
                    <th>비방등록자</th>
                    <th>평점</th>
                    <th>😇</th>
                    <th>👿</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="formulaLibraryList.length == 0">
                    <td colspan="9"><span>데이터가 없습니다.</span></td>
                  </tr>
                  <tr
                    v-for="(item, index) in formulaLibraryList"
                    :key="index"
                    @click="fn_move_dtl_page(item)"
                  >
                    <td>
                      <span>{{ searchInfo.pageInfo.totPage - ( (searchInfo.pageInfo.page - 1) * searchInfo.pageInfo.pageSize) - index}}</span>
                    </td>
                    <td>
                      <span>{{ item.prescribe_nm }}</span>
                    </td>
                    <td>
                      <span>{{ item.prescribe_category_nm }}</span>
                    </td>
                    <td>
                      <span>{{ item.indications }}</span>
                    </td>
                    <td>
                      <span>{{ item.prescribe_source }}</span>
                    </td>
                    <td>
                      <span>{{ item.nick_nm }}</span>
                    </td>
                    <td>
                      <StarRating :rating="item.avg_clinical_rating" />
                    </td>
                    <td>
                      <span>{{item.recommendCount}}</span>
                    </td>
                    <td>
                      <span>{{item.notRecommendCount}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Pagination :pageInfo="searchInfo.pageInfo"  @clickPage="fn_movePage" v-show="pagingShow"/>
          </div>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import StarRating from "@/components/common/StarRating.vue";
import Pagination from "@/components/AdminPagination.vue"

export default {
  components: {
    Pagination,
    StarRating,
  },
  mixins: [commonUtil],
  data() {
    return {
      searchInfo : {
          doctor_nm : '',
          prescribe_nm : '',
          prescribe_category : '',
          prescribe_sub_category : '',
          indications : '',         
          pageInfo : {
              page : 1,
              pageSize : 10,
              totPage : 0
          }              
      },
      pagingShow : false,
      prescrbeCategoryList : [],
      prescrbeSubCategoryList : [],
      formulaLibraryList: [],
      selected: null,
    };
  },
  async created(){

    //검색정보 처리
    let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];             

    if(searchInfoStore != null && searchInfoStore != {}){
        this.searchInfo = searchInfoStore;
    }

    //처방 카테고리
    this.prescrbeCategoryList = await this.getCode('GC00000015'); 
  },
  mounted(){
      this.fn_search();
  },
  methods : {
    fn_search(){

      this.$store.dispatch('commonStore/setSearchInfo', this.searchInfo); 

      axios
          .post("/api/user/hanidata/getFormulaLibraryList", this.searchInfo)
          .then((res) => {
              console.log("@@@@ res : %o",res);
              this.formulaLibraryList = res.data.formulaLibraryList;

              this.searchInfo.pageInfo.totPage = res.data.totCnt;
              
              if(this.searchInfo.pageInfo.totPage> 0){
                  this.pagingShow = true;                          
              }                        

          })
          .catch((err) => console.log(err));
    },
    fn_movePage(page){
      this.searchInfo.pageInfo.page = page;
      this.fn_search();
    },
    fn_move_dtl_page(item){

        this.$store.dispatch('detailSearchInfo/setSearchInfo', item);
        this.$router.push({ name : 'FormulaLibraryDetail'});
    },
    fn_move_mySecret(){
      this.$store.dispatch('detailSearchInfo/setSearchInfo', {});
      this.$router.push("/hanidata/myFormulaLibraryList");
    },
    async fn_change_prescript_catarory(){

      // 선택된 카테고리에 따른 상세 변경 처리
      if(this.searchInfo.prescribe_category !== ''){
        //카테고리값을 선택한 경우
        const list = await this.getDtlCode('GC00000015',this.searchInfo.prescribe_category);
        this.prescrbeSubCategoryList = list || [];
      }else{
        //카테고리값을 선택으로 초기화 한 경우
        this.prescrbeSubCategoryList = [];
      }

      // 기선택 정보 초기화
      this.searchInfo.prescribe_sub_category = '';
    }
  }
};
</script>

<style scoped>
.search_row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.search_fields {
  display: grid;
  grid-template-columns: 80px 410px 80px 310px;
  column-gap: 20px;
  align-items: center;
}
.formula_title_wrap {
  width: 100%;
  padding: 0 0 10px;
}
.title_formula_img {
  max-width: 100%;
  height: auto;
  display: block;
}
</style>
